import {
  pxToRem,
  responsiveFontSizes,
  responsiveLineHeight,
} from '../utils/getFontValue';

// ----------------------------------------------------------------------

const FONT_PRIMARY = '"Instrument Sans", sans-serif'; // Google Font (public/index.html)
// const FONT_SECONDARY = 'CircularStd, sans-serif'; // Local Font

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: pxToRem(80),
    fontSize: pxToRem(40),
    letterSpacing: 2,
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontWeight: 700,
    lineHeight: pxToRem(70),
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 32, md: 32, lg: 32 }),
  },
  h3: {
    fontWeight: 700,
    lineHeight: pxToRem(24),
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
    ...responsiveLineHeight({ sm: 32, md: 32, lg: 32 }),
  },
  h4: {
    fontWeight: 700,
    lineHeight: pxToRem(24),
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
    ...responsiveLineHeight({ sm: 32, md: 32, lg: 32 }),
  },
  h5: {
    fontWeight: 700,
    lineHeight: pxToRem(24),
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
    ...responsiveLineHeight({ sm: 32, md: 32, lg: 32 }),
  },
  h6: {
    fontWeight: 700,
    lineHeight: pxToRem(24),
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: pxToRem(24),
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: pxToRem(22),
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: pxToRem(22),
    fontSize: pxToRem(16),
  },
  body2: {
    lineHeight: pxToRem(20),
    fontSize: pxToRem(14),
  },
  caption: {
    lineHeight: pxToRem(17),
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 700,
    lineHeight: pxToRem(30),
    fontSize: pxToRem(14),
    textTransform: 'capitalize',
  },
} as const;

export default typography;
